import { render, staticRenderFns } from "./OrderSelectContact.vue?vue&type=template&id=172fce72&"
import script from "./OrderSelectContact.vue?vue&type=script&lang=js&"
export * from "./OrderSelectContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports